import React from 'react';
import FishermanIcon from '../../../Icon';
var defaultProps = {};
export default function Icon(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/React.createElement(FishermanIcon, {
    className: "social-platform-icon",
    iconName: (icon || '').toLowerCase()
  });
}
Icon.defaultProps = defaultProps;